import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet';
import ScrollTopOnMount from 'components/utility/ScrollTopOnMount/ScrollTopOnMount';
import NotificationSettingsModal from '../../components/notifications/Settings';
import BackToTop from 'components/BackToTop/BackToTop';
import Footer from 'components/Footer/Footer';
import SystemStatusHeader from 'components/SystemStatus/Header';
import StatusUpdateSkeletonLoader from 'components/SystemStatus/StatusUpdateSkeletonLoader';
import SystemDataSectionSkeletonLoader from 'components/SystemStatus/SystemDataSectionSkeletonLoader';

const StatusUpdatesSection = React.lazy(() =>
  import('components/SystemStatus/StatusUpdatesSection')
);
const SystemDSPDataSection = React.lazy(() =>
  import('components/SystemStatus/SystemDataSection')
);

const SystemStatus: React.FC = () => {
  return (
    <>
      <ScrollTopOnMount />
      <Helmet defer={false} title="System Status" />

      <NotificationSettingsModal />

      <SystemStatusHeader />

      <div role="main">
        <Suspense
          fallback={<StatusUpdateSkeletonLoader title="Status Update" />}
        >
          <StatusUpdatesSection title="Status Update" />
        </Suspense>
        <Suspense
          fallback={
            <SystemDataSectionSkeletonLoader sectionLabel="Streaming DSP Data" />
          }
        >
          <SystemDSPDataSection
            sectionDataType="streaming"
            sectionLabel="Streaming DSP Data"
            sectionGlossaryLink="glossary/kpis/streaming-kpis"
            defaultDSPIdList={[155643, 5, 119735, 2, 3, 1, 140003]}
          />
        </Suspense>

        <Suspense
          fallback={
            <SystemDataSectionSkeletonLoader sectionLabel="Chart Data" />
          }
        >
          <SystemDSPDataSection
            sectionDataType="charts"
            sectionLabel="Chart Data"
            sectionGlossaryLink="glossary/charts-graphs-tables/performance-trend"
          />
        </Suspense>

        <Suspense
          fallback={
            <SystemDataSectionSkeletonLoader sectionLabel="Playlist Data" />
          }
        >
          <SystemDSPDataSection
            sectionDataType="playlist"
            sectionLabel="Playlist Data"
            sectionGlossaryLink="glossary/"
          />
        </Suspense>
      </div>

      <BackToTop />
      <Footer />
    </>
  );
};

export default SystemStatus;
